import propTypes from 'prop-types'
import {Box} from '@chakra-ui/react'

const PrimaryProgressBar = ({isProgressed}) => (
  <Box
    backgroundColor={isProgressed ? 'mld.neutral.900' : 'mld.neutral.200'}
    flexGrow="1"
    height="2px"
    marginBottom="8px"
    borderRadius="4px"
  />
)

PrimaryProgressBar.propTypes = {
  isProgressed: propTypes.bool.isRequired,
}

export default PrimaryProgressBar
